import { render, staticRenderFns } from "./Content_es.vue?vue&type=template&id=36b662d0&"
import script from "./Content_es.vue?vue&type=script&lang=js&"
export * from "./Content_es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports